// extracted by mini-css-extract-plugin
export default {"container":"MainBlock_container__D4EkR"};